module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/106-panama-902c4877845478e641d9bdec9edcdab7.svg";